import { Component, OnInit } from '@angular/core';
import { LeoService } from './leo.service';
import { Leo } from './leo.model';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { CustomValidators } from '../../../core/custom-validators';

@Component({
  selector: 'app-leo',
  templateUrl: './leo.component.html',
  styleUrls: ['./leo.component.css'],
})


export class LeoComponent implements OnInit {
  formbuilder: any;
  formGroup: any;
  leoData: Leo = new Leo();
  leoForm: UntypedFormGroup;
  displayerror: boolean;
  formgroup: UntypedFormGroup;
  allStates = [];
  allCounties = [];
  //Show a list of the form inputs after a successful save of the form
  completionPage: boolean;
  errorMessage: string = "";
  displayModal = 'none';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private service: LeoService,
    private router: Router
  ) { }



  public phoneMask = '(000) 000-0000';

  public reporting = Array<{ value: string; display: string; year: number }>();



  ngOnInit() {
    this.leoForm = this.formBuilder.group({
      developerName: [null, Validators.compose([Validators.required, CustomValidators.noSpace, Validators.maxLength(200)])],
      address1: [null, Validators.compose([Validators.required, CustomValidators.noSpace, Validators.maxLength(200)])],
      address2: [null, Validators.compose([Validators.maxLength(200)])],
      city: [null, Validators.compose([Validators.required, CustomValidators.noSpace, Validators.maxLength(100)])],
      state: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
      zip: [null, Validators.compose([Validators.required, CustomValidators.noSpace, CustomValidators.zipCodeInvalid])],
      contactPerson: [null, Validators.compose([Validators.required, CustomValidators.noSpace, Validators.maxLength(200)])],
      contactPhone: [null, Validators.compose([Validators.required, CustomValidators.noSpace, CustomValidators.PhoneNumberValid, CustomValidators.noSpace])],
      directEmail: [null, Validators.compose([Validators.required, CustomValidators.noSpace, CustomValidators.validEmail, CustomValidators.noSpace, Validators.maxLength(200)])],
      docketFilingNumber: [null, Validators.compose([Validators.required, CustomValidators.noSpace, CustomValidators.DocketFilingNumberValid])],
      interconnectingUtility: [null, Validators.compose([Validators.required, CustomValidators.noSpace, Validators.maxLength(200)])],
      projectSize: [null, Validators.compose([Validators.required, CustomValidators.noSpace, Validators.maxLength(100)])],
      dateFiled: [null, Validators.compose([Validators.required, CustomValidators.validDateFormat])],
      utilityIdentification: [null, Validators.compose([Validators.maxLength(100)])],
      technologyType: [null, Validators.compose([Validators.required, CustomValidators.noSpace, Validators.maxLength(200)])],
      county: [null, Validators.compose([Validators.required])],
      descriptionOfProject: [null, Validators.compose([Validators.required, CustomValidators.noSpace, Validators.maxLength(1000)])],
      dateEstablishedLeo: [null, Validators.compose([Validators.required, CustomValidators.validDateFormat])],
      //dateEstablishedLeo: [null, [this.isIE ? Validators.compose([Validators.required, Validators.pattern(this.dateFormat)]) : Validators.compose([Validators.required, CustomValidators.nativedate])]],  
      seekingLeoForEnergyOrCapacity: [null, Validators.compose([Validators.required, CustomValidators.noSpace, Validators.maxLength(200)])],
      stepsToMeetCriteria: [null, Validators.compose([Validators.required, CustomValidators.noSpace, Validators.maxLength(1000)])],
      goodFaithEffort: [null, Validators.compose([Validators.required, CustomValidators.noSpace, Validators.maxLength(1000)])],
      natureOfConflict: [null, Validators.compose([Validators.required, CustomValidators.noSpace, Validators.maxLength(1000)])]
    });


    this.getAllStates();
    this.getAllCounties();
    this.leoData.developerName = null;
    this.leoData.address1 = null;
    this.leoData.address2 = null;
    this.leoData.city = null;
    this.leoData.state = null;
    this.leoData.zip = null;
    this.leoData.contactPerson = null;
    this.leoData.contactPhone = null;
    this.leoData.directEmail = null;
    this.leoData.docketFilingNumber = 'QF-';
    this.leoData.interconnectingUtility = null;
    this.leoData.projectSize = null;   
    this.leoData.dateFiled = null;
    this.leoData.utilityIdentification = null;
    this.leoData.technologyType = null;
    this.leoData.county = null;
    this.leoData.descriptionOfProject = null;
    this.leoData.dateEstablishedLeo = null;
    this.leoData.seekingLeoForEnergyOrCapacity = null;
    this.leoData.seekingLeoForEnergyOrCapacity = null;
    this.leoData.stepsToMeetCriteria = null;
    this.leoData.goodFaithEffort = null;
    this.leoData.natureOfConflict = null;
  }

  formatMoney(c) {
    c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  }

  calculate() {
    //  if (
    //    +this.leoData.serviceRevenueRetail >= 0 &&
    //    +this.leoData.uncollectibleRevenues >= 0 
    //  ) {
    //    this.leoData.telecommunicationsRetail = (+this.leoData.serviceRevenueRetail - +this.leoData.uncollectibleRevenues).toFixed(2).toString();
    //    this.leoData.contributionAmount = (+this.leoData.telecommunicationsRetail <= 0 ? 0 : (+this.leoData.telecommunicationsRetail *
    //      this.leoData.contributionPercentage).toFixed(2)).toString();
    // } else {
    //   this.leoData.telecommunicationsRetail = null;
    //   this.leoData.contributionAmount = null;
    //}
  }

  //Opens and closes the bootstrap modal that displays when there is an error
  modalOpenClose() {
    if (this.displayModal == 'block') {
      this.displayModal = 'none';
    }
    else {
      this.displayModal = 'block';
    }

  }

  getAllStates() {
    this.service.GetStates('').subscribe(statesData => {
      if (statesData) {
        this.allStates = statesData;
      }
      else{
        this.errorMessage = "An error occurred while connecting to the database. Please try again.";
        this.displayModal = 'block';
      }
    });
  }

  getAllCounties() {
    this.service.GetCounties('').subscribe(countiesData => {
      if (countiesData) {
        this.allCounties = countiesData;
      }
    });
  }


  saveLeo() {
    if (!this.leoForm.valid) {
        //The form is not valid. Set each field as touched so the error messages will show
      Object.keys(this.leoForm.controls).forEach((key) => {
        this.leoForm.get(key).markAsTouched();
      });

      //Focus the first invalid field
      var foundInvalid = false;      
      Object.keys(this.leoForm.controls).forEach((key) => {     
        if (this.leoForm.controls[key].invalid) {          
            if (foundInvalid == false) {
            document.getElementById(key).focus();
            foundInvalid = true;
          }
        }
      });

    } else {
      const params = {
        'DeveloperName': this.leoData.developerName,
        'Address1': this.leoData.address1,
        'Address2': this.leoData.address2,
        'State': this.leoData.state,
        'Zip': this.leoData.zip,
        'ContactPerson': this.leoData.contactPerson,
        'ContactPhone': this.leoData.contactPhone,
        'DirectEmail': this.leoData.directEmail,
        'DocketFilingNumber': this.leoData.docketFilingNumber,
        'InterconnectingUtility': this.leoData.interconnectingUtility,
        'ProjectSize': this.leoData.projectSize,        
        'DateFiled': this.leoData.dateFiled,
        'UtilityIdentification': this.leoData.utilityIdentification,
        'TechnologyType': this.leoData.technologyType,
        'County': this.leoData.county,
        'DescriptionOfProject': this.leoData.descriptionOfProject,
        'DateEstablishedLeo': this.leoData.dateEstablishedLeo,
        'SeekingLeoForEnergyOrCapacity': this.leoData.seekingLeoForEnergyOrCapacity,
        'StepsToMeetCriteria': this.leoData.stepsToMeetCriteria,
        'GoodFaithEffort': this.leoData.goodFaithEffort,
        'NatureOfConflict': this.leoData.natureOfConflict
      };

      
      this.service.SaveLeo(this.leoData).subscribe(pData => {
        if (pData.success && pData.errorMessage == null) {
          this.completionPage = true;
          this.errorMessage = "";
          window.scroll(0,0)
        }
        else if(pData.success && pData.errorMessage != null){
          this.completionPage = true;
          this.errorMessage =  pData.errorMessage;
          this.displayModal = 'block';
          window.scroll(0,0)
        }
        else {
          this.completionPage = false;
          this.errorMessage =  pData.errorMessage;
          this.displayModal = 'block';
        }
      });
    }
  }

  Menu() {
    this.router.navigateByUrl('/forms-home');
  }


  goBack() {
    this.completionPage = false;
    this.leoData = new Leo();
    Object.keys(this.leoForm.controls).forEach(key => {
      this.leoForm.get(key).markAsUntouched();
    });
    this.ngOnInit();
  }


}
